import DistrictManagerPage from './pages/DistrictManagerPage';
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import LoginPage from './pages/LoginPage';
import TechnicianPage from './pages/TechnicianPage';
import CoordinatorPage from './pages/CoordinatorPage';
import InspectorPage from './pages/InspectorPage';
import ProtectedRoute from './components/common/ProtectedRoute';
import PortalAdmin from './pages/PortalAdmin'; // ✅ CAMBIO 1: Reemplazar AdminPage
import PWABanner from './components/common/PWABanner';

function App() {
  const basename = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
  return (
    <AuthProvider>
      <Router basename={basename}>
        <PWABanner />
        <Routes>

          <Route path="/gerente-distrito" element={
            <ProtectedRoute roleRequired="district_manager">
              <DistrictManagerPage />
            </ProtectedRoute>
          } />
          <Route index element={<Navigate to="/login" replace />} />
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/formulario" element={
            <ProtectedRoute roleRequired="technician">
              <TechnicianPage />
            </ProtectedRoute>
          } />
          <Route path="/coordinador" element={
            <ProtectedRoute roleRequired="coordinator">
              <CoordinatorPage />
            </ProtectedRoute>
          } />
          {/* ✅ Usar PortalAdmin para admin y district_manager */}
          <Route path="/admin" element={
            <ProtectedRoute roleRequired={['admin', 'district_manager']}>
              <PortalAdmin />
            </ProtectedRoute>
          } />
          <Route path="/inspector" element={
            <ProtectedRoute roleRequired="inspector">
              <InspectorPage />
            </ProtectedRoute>
          } />
          {/* ✅ Fallback para evitar pantalla en blanco si no hay coincidencia exacta de ruta */}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;